import React, { useState, useEffect } from 'react';
import { useNotification } from '../../context/NotificationContext';
import { settingsAPI } from '../../utils/api';

const AdminSettings = () => {
    const { showSuccess, showError } = useNotification();
    const [commission, setCommission] = useState(10);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchSettings = async () => {
        try {
            const res = await settingsAPI.getCommission();
            if (res.data.success) {
                setCommission(res.data.data.percentage);
            }
        } catch (error) {
            showError('Failed to fetch settings');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            await settingsAPI.setCommission({ percentage: parseFloat(commission) });
            showSuccess('Commission updated successfully');
        } catch (error) {
            showError('Failed to update commission');
        }
    };

    if (loading) return <div className="text-center py-8">Loading settings...</div>;

    return (
        <div className="max-w-2xl mx-auto space-y-8">
            <h1 className="text-2xl font-bold text-gold">System Settings</h1>

            <div className="bg-gray-800 p-6 rounded-xl">
                <h2 className="text-xl font-semibold mb-4">Financial Settings</h2>

                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium mb-2 text-gray-300">
                            Retailer Commission Percentage (%)
                        </label>
                        <p className="text-xs text-gray-400 mb-2">
                            Percentage deducted from retailer sales before wallet credit.
                        </p>
                        <div className="flex gap-4">
                            <input
                                type="number"
                                min="0"
                                max="100"
                                value={commission}
                                onChange={(e) => setCommission(e.target.value)}
                                className="bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 w-32 focus:border-gold outline-none"
                            />
                            <button
                                onClick={handleSave}
                                className="bg-gold text-dark px-6 py-2 rounded-lg font-bold hover:opacity-90"
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;
